module.exports = __webpack_public_path__ + "static/img/exp1.c86ca7fa.png";